<template>
	<button
		aria-label="Nach unten Scrollen"
		v-scroll-to="{ el: '.fullwidth-container' }"
		class="headvisual--scroll-indicator btn"
		data-aos="fade-up"
		data-aos-duration="1100"
		data-aos-delay="1100"
	>
		<MouseIcon />
	</button>
</template>

<script>
import MouseIcon from './MouseIcon';
export default {
	components: {
		MouseIcon
	},
}
</script>

<style lang="scss">
@import '~@/assets/scss/common';
$headvisual--scroll-indicator--size: 40px !default;
$headvisual--scroll-indicator--color: color(white) !default;
$headvisual--scroll-indicator--transition-duration: $default--animation-duration !default;
$headvisual--scroll-indicator--transition-timing-function: $default--animation-easing !default;
$headvisual--scroll-indicator--background: color(secondary, base) !default;
$headvisual--scroll-indicator--background-hover: color(primary, base) !default;
$headvisual--scroll-indicator--width: 80px !default;

.headvisual--scroll-indicator {

	display: none;

	@include media-breakpoint-up(lg) {

		cursor: pointer;
		display: block;
		position: absolute;
		bottom: 50px;
		left: 50%;
		// left: 15%;
		transform: translate3d(-50%, 0, 0);
		display: block;
		text-decoration: none;
		border-radius: 100em;
		overflow: hidden;
		z-index: 4;
		font-size: rem($headvisual--scroll-indicator--size);
		color: $headvisual--scroll-indicator--color;
		background: $headvisual--scroll-indicator--background;
		width: $headvisual--scroll-indicator--width;
		height: $headvisual--scroll-indicator--width;

		// Dynamically center all children horizontally and vertically
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		fill: $white;

		&.btn {
			padding: 0;
			width: $headvisual--scroll-indicator--width;
			height: $headvisual--scroll-indicator--width;
		}

		.svg-inline--fa {
			height: 50px;
		}

		.apply-transitions & {
			transition: transform $headvisual--scroll-indicator--transition-duration $headvisual--scroll-indicator--transition-timing-function;
		}

		&:hover,
		&:focus {
			color: $headvisual--scroll-indicator--color;
			background-color: $headvisual--scroll-indicator--background-hover;
		}
	}
}
</style>
